/**
 * The zone an entity's working day is measured in.
 *
 * A mirror of the backend's utils/zonedTime: this only prefills and validates a
 * field somebody can change, the server derives it again on write, and the
 * server's answer is what is stored. The two drifting costs a wrong suggestion,
 * never a wrong attendance record.
 *
 * IANA names rather than offsets, because offsets move — +00:00/+01:00 for
 * London is not a constant, and a stored offset is wrong twice a year.
 */

const COUNTRY_ZONE = {
  INDIA: "Asia/Kolkata", IN: "Asia/Kolkata",
  SINGAPORE: "Asia/Singapore", SG: "Asia/Singapore",
  "UNITED ARAB EMIRATES": "Asia/Dubai", UAE: "Asia/Dubai", AE: "Asia/Dubai",
  "UNITED KINGDOM": "Europe/London", UK: "Europe/London", GB: "Europe/London",
  IRELAND: "Europe/Dublin", IE: "Europe/Dublin",
  GERMANY: "Europe/Berlin", DE: "Europe/Berlin",
  FRANCE: "Europe/Paris", FR: "Europe/Paris",
  NETHERLANDS: "Europe/Amsterdam", NL: "Europe/Amsterdam",
  SPAIN: "Europe/Madrid", ES: "Europe/Madrid",
  JAPAN: "Asia/Tokyo", JP: "Asia/Tokyo",
  AUSTRALIA: "Australia/Sydney", AU: "Australia/Sydney",
  CANADA: "America/Toronto", CA: "America/Toronto",
  "UNITED STATES": "America/New_York", USA: "America/New_York", US: "America/New_York",
};

export const DEFAULT_ZONE = "Asia/Kolkata";

export const timezoneForCountry = (country) =>
  COUNTRY_ZONE[String(country || "").trim().toUpperCase()] || DEFAULT_ZONE;

/**
 * What the picker offers. The browser's own list where it has one — every
 * current engine implements supportedValuesOf — and the countries this product
 * actually serves where it does not, so an older browser still gets a usable
 * field rather than an empty one.
 */
export const TIMEZONES = (() => {
  try {
    const all = Intl.supportedValuesOf?.("timeZone");
    if (Array.isArray(all) && all.length) return all;
  } catch {
    /* fall through */
  }
  return [...new Set(Object.values(COUNTRY_ZONE))].sort();
})();
